import { Component, Inject } from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import { AdminApi } from '../admin-api';


@Component({
  selector: 'app-delete-pdf-template',
  templateUrl: './delete-pdf-template.component.html',
  styleUrls: ['./delete-pdf-template.component.css']
})
export class DeletePdfTemplateComponent {

  disableButton = false;

   constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<DeletePdfTemplateComponent>, private api: AdminApi) {}

   onClickOk() {
      if (this.data.templateList.length > 0 && !this.data.templateId) {
         for (let i = 0; i < this.data.templateList.length; i++) {
            this.deleteTemplateList(this.data.templateList[i].templateId);
         }
      } else {
         this.deleteTemplateList(this.data.templateId);
      }
   }

   deleteTemplateList(templateId) {
      this.api.deleteTemplateList(templateId).subscribe((res) => {
         this.disableButton = true;
         this.dialogRef.close({response: true, msg: res});
      });
   }
}
